import React from "react";
import { useSearchParams } from "react-router-dom";
import { queryParams } from "../../../../helpers/UrlHelpers";
import minecraftUrls from "../../../../configs/mine_craft/minecraftUrls";

import PageHeader from "../../../../componets/PageHeader";
import NavBarTwo from "../../../../componets/NavBarTwo";

// Same header pattern as the Community pages (see Addons/_partials/
// _PageHeader): the shared PageHeader carries the title + breadcrumb,
// NavBarTwo the section navigation, with Account as the parent entry —
// the "All" of this page. Sections travel in the `tab` query param so
// deep links keep working.
const ITEMS: { [index: number]: any } = {
  1: {
    id: 1,
    name: 'Leaderboard',
    slug: 'leaderboard'
  },
  2: {
    id: 2,
    name: 'Webhook Deliveries',
    slug: 'deliveries'
  }
};

const _PageHeader: React.FC = () => {
  const [searchParams] = useSearchParams();
  const tab = queryParams.get(searchParams, 'tab');

  const items = Object.fromEntries(
    Object.values(ITEMS).map(item => [
      item.id,
      { ...item, url: minecraftUrls.hostingPath({ tab: item.slug }) }
    ])
  );
  const activeItem = Object.values(ITEMS).find(item => item.slug === tab);

  return (
    <PageHeader
      title='Hosting'
      breadcrumbs={[activeItem?.name || 'Account']}
    >
      <NavBarTwo
        items={items}
        itemIds={Object.keys(items)}
        parent={{
          name: 'Account',
          url: minecraftUrls.hostingPath(),
          isActive: () => !activeItem
        }}
        activeId={activeItem?.id}
      />
    </PageHeader>
  );
}

export default _PageHeader;
